m = require 'mithril'
CommonViews  = require './CommonViews'
ControlBlock = require './ControlBlock'

ImportSelectionPane = {
	controller: (args) ->
		ctrl = @
		ctrl.selectedIds = {}
		ctrl.onSelection = () ->
			selectedGames = (g for g in args.games when ctrl.selectedIds[g.id] is true)
			args.onImport selectedGames
		ctrl

	view: (ctrl, args) ->
		m '.importselectionpane', [
			m 'h2', 'Import'
			m 'p', 'Select the games you would like to import.'
			m 'ul', args.games.map (game) ->
				m 'li', m 'label', [
					m "input[type=checkbox][name=#{game.id}]", {
						onchange: m.withAttr 'checked', (selected) -> ctrl.selectedIds[game.id] = selected
					}
					"[#{game.date}] #{game.label} (#{(p.name for p in game.players).join ', '})"
				]

			m ControlBlock, {content: [
				m 'button.importselectionpane__button', {
					onclick: ctrl.onSelection
				}, [
					CommonViews.icon CommonViews.icons.floppydisk, 'importselectionpane__buttonicon'
					'Import selected games'
				]
			]}
		]
}

module.exports = ImportSelectionPane